<p *ngIf="plaformFee && fundraiser?.tip_model" class="platform-fee d-lg-none d-md-none d-sm-none d-block">Ketto charges <span>0% platform fee*</span> for this fundraiser</p>
<button (click)="donateNow(paymentModule)" id="donate-now-button" class="donation-button" [ngClass]="version" mat-raised-button [disabled]="isLoading || checkSupportingStatus()" color="primary" [hidden]="!fundraiser?.settings?.donation_button">
  <div *ngIf="!isLoading" class="button-wrapper">
    <i *ngIf="icon" class="material-icons filled-heart" matPrefix>favorite</i>
    <div *ngIf="!showLabel" class="label">{{label}}</div>
    <div *ngIf="showLabel && (!qParams.mini_story || !miniStory)" class="varlabel">
      <div class="label">{{fundraiser?.cta_label?.info_1 || label}}</div>
      <div *ngIf="fundraiser?.cta_label?.info_2 && showLabel" class="sub-text">{{fundraiser?.cta_label?.info_2}}</div>
    </div>
  </div>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>

<ng-template #paymentModule>
  <app-main-payment *ngIf="fundraiser" [internal]="true" [fundraiser]="fundraiser" [sipCause]="sipCause"
                    [origin]="getOrigin()" [showBeneficiary]="showBeneficiary" [type]="dialogType" [isBtnClicked]="isBtnClicked"
                    [isRewardSelected]="isRewardSelected" [isQR]="isQR" [updateId]="updateId" [skipFailedCase]="skipFailedCase"
                    [paymentIcons]="paymentIcons" [recommendTag]="recommendTag" [customTheme]="customTheme" [inputFields]="inputFields"
                    [headerType]="headerType" [isSipStory]="isSipStory" [tagLabel]="tagLabel" [theme]="theme">
  </app-main-payment>
</ng-template>
